export const TEST_ID = 'baseNotification';
